import { http } from '@/api/http';

export interface DbPoolEntryDto {
  readonly pool_name: string | null;
  readonly tenant_key: string | null;
  readonly active_connections: number;
  readonly idle_connections: number;
  readonly total_connections: number;
  readonly threads_awaiting: number;
  readonly maximum_pool_size: number;
  readonly minimum_idle: number;
  readonly connection_timeout_ms: number;
  readonly idle_timeout_ms: number;
  readonly max_lifetime_ms: number;
  readonly leak_detection_threshold_ms: number;
}

export interface DbServerStatsDto {
  readonly threads_connected: number | null;
  readonly threads_running: number | null;
  readonly max_used_connections: number | null;
  readonly aborted_connects: number | null;
  readonly max_connections: number | null;
}

export interface DbProcessEntryDto {
  readonly id: number | null;
  readonly user: string | null;
  readonly host: string | null;
  readonly db: string | null;
  readonly command: string | null;
  readonly time_seconds: number | null;
  readonly state: string | null;
  readonly info: string | null;
}

export interface DbPoolStatsDto {
  readonly pools: readonly DbPoolEntryDto[];
  readonly server: DbServerStatsDto;
  readonly process_list: readonly DbProcessEntryDto[];
  readonly captured_at: string;
}

export const adminDbPoolEndpoints = {
  /**
   * GET /system/pool-stats — admin-only DB connection-pool snapshot.
   *
   * Returns one entry per Hikari pool, the MariaDB server's view of total open connections,
   * and a truncated `SHOW PROCESSLIST` for triage. Same admin gating as `/system/build-info`.
   * Local types until the ai-hub OpenAPI contract is updated; the snake_case shape mirrors
   * `libs/commons-lib/.../dto/system/response/DbPoolStatsDTO.java`.
   */
  getDbPoolStats: (options?: { signal?: AbortSignal }): Promise<DbPoolStatsDto> =>
    http.get<DbPoolStatsDto>('/system/pool-stats', options),
};
